import axios from "axios";
import { isObject } from "formik";
import Swal from "sweetalert2";
import api from "./api_refresh_token";
import { baseURL } from "./api_base";

axios.defaults.headers.common["Access-Control-Allow-Origin"] =
  "GET, POST, DELETE, PUT"; // definindo o que meu axios pode fazer


//Token
const getToken = () => {
  let token = localStorage.getItem("token");
  return token;
};

export const getPerfilCadastro = (body) =>
  api
    .post(
      `${baseURL}/perfis_store`,
      // url base + rota de busca
      body,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": `application/json`,
        },
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )
      //console.log(response);
      Swal.fire({
        icon: "success",
        title: "Perfil cadastrado com sucesso",
      });
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });
// buscar os id's
export const getPerfilById = (id) =>
  api
    .get(
      `${baseURL}/perfis/${id}`,

      // url base + rota de busca
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )
      //console.log(response)
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });

//put
export const getPerfilUpdate = (id, body) =>
  api
    .put(
      `${baseURL}/perfis_update/${id}`,
      // url base + rota de busca
      body,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": `application/json`,
        },
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )
      Swal.fire({
        icon: "success",
        title: "Registro alterado com sucesso",
      });
      return response;
    })
    .catch((error) => {})
    .then(function (response) {
      return response;
    });

//delete
export const deletePerfil = (id) =>
  api
    .delete(
      `${baseURL}/perfis_delete/${id}`,
      // url base + rota de busca

      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": `application/json`,
        },
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )

      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });
